
const maxNameCharacters = 18

export const shortenName = (completeName: string): string => {
    if (completeName.length <= maxNameCharacters) return completeName
    const names = completeName.split(' ')
    if (names.length <= 2) return completeName.substring(0, maxNameCharacters)
    return shortenName(names.filter(n => n !== names[names.length - 2]).join(' '))
}

export const formatEuros = (value?: number|string|{sum: number, count: number}) => value === undefined  ? ''
: typeof value === 'string' ? value
: typeof value === 'number' ? `${(isNaN(value) ? 0 : value).toFixed(2)} €`
: `${(!value || isNaN(value.sum) ? 0 : value.sum).toFixed(2)} € (${value?.count ?? 0})`

export const asSnake = (value: string): string => value.toLocaleLowerCase().replace(' ', '-')

export const sanitize = (value: string): string => value.toLowerCase().replace(' ', '_')

/**
 * Extracts initials from a name, username, or email for avatar display.
 * Priority: name → username → email
 * Returns 1-2 uppercase letters
 */
export const getInitials = (name?: string, username?: string, email?: string): string => {
    const source = name || username || email || '';
    if (!source) return '';

    // If it's an email, use part before @
    const nameFromEmail = source.includes('@') ? source.split('@')[0] : source;

    // Split by space and take first letter of first two words
    const words = nameFromEmail.trim().split(/\s+/);
    if (words.length >= 2) {
        return (words[0][0] + words[1][0]).toUpperCase();
    }

    // Single word: take first 1-2 characters
    return nameFromEmail.substring(0, 2).toUpperCase();
}
